// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3uNzV","dragIcon":"Choice_dragIcon__1e7BA","left":"Choice_left__4gGhI","input":"Choice_input__O7QhA"};